import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { TextField } from '../../components/ui/Field';
import { ChoiceChip } from '../../components/ui/Choice';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import type { StepProps } from '../../types/quiz';
export function StepChildName({
  profile,
  update,
  onNext
}: StepProps) {
  const canContinue = profile.child_name.trim().length > 0 && profile.child_gender !== '';
  return <div className="flex flex-1 flex-col" data-id="element-98" data-mp="1kykrq9hh9fmd">
      <Headline data-id="element-99" data-mp="1pu9s2f1bn0jq">¿Cómo se llama tu pequeño? 💜</Headline>
      <Subtext data-id="element-100" data-mp="1px5twegai9dg">Usaremos su nombre dentro de las experiencias de audio.</Subtext>

      <div className="mt-6" data-id="element-101" data-mp="1b4cbak5q1d4k">
        <TextField id="child-name" label="Nombre o apodo" value={profile.child_name} onChange={value => update({
        child_name: value
      })} placeholder="Martina" data-id="element-102" data-mp="1g58eevi90v8x" />
      </div>

      <fieldset className="mt-8" data-id="element-103" data-mp="28muhfmhtanis">
        <legend className="font-display text-xl font-semibold text-ink" data-id="element-104" data-mp="28n416sc9jyg1">¿Es hijo o hija?</legend>
        <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-105" data-mp="3cv9d4z7rux7t">
          <ChoiceChip emoji="💙" label="Hijo" selected={profile.child_gender === 'hijo'} onSelect={() => update({
          child_gender: 'hijo'
        })} data-id="element-106" data-mp="37wociyolybiu" />
          <ChoiceChip emoji="💗" label="Hija" selected={profile.child_gender === 'hija'} onSelect={() => update({
          child_gender: 'hija'
        })} data-id="element-107" data-mp="3htszv1u6wd18" />
        </div>
      </fieldset>

      <div className="mt-auto pt-10" data-id="element-108" data-mp="3qluycukp7j8v">
        <PrimaryButton onClick={onNext} disabled={!canContinue} data-id="element-109" data-mp="9e9aidwn3erg">
          Continuar →
        </PrimaryButton>
      </div>
    </div>;
}